<template>
  <div class="w-full max-w-xs m-auto self-center">
    <div class="flex justify-center pt-12 pb-8">
      <img class="h-12" :src="!config.logoPath || url.resolve(config.URL.API.host, config.logoPath)" alt="">
    </div>
    <form class="bg-theme-400 shadow-md rounded px-8 pt-6 pb-8 mb-4" v-on:submit.prevent="login">
      <div class="mb-4">
        <label class="block text-sm font-bold mb-2" for="email">
          Email
        </label>
        <input
          class="form-control"
          :class="{ 'border border-red-500': emptyEmail }"
          id="email"
          type="email"
          v-model="email"
        >
        <p class="text-red-500 text-xs italic mt-0" v-show="emptyEmail">Please type your email</p>
      </div>
      <div class="mb-6">
        <label class="block text-sm font-bold mb-2" for="password">
          Password
        </label>
        <input
          class="form-control"
          :class="{ 'border border-red-500': emptyPassword }"
          id="password"
          type="password"
          autocomplete="on"
          v-model="password"
        >
        <p class="text-red-500 text-xs italic mt-0" v-show="emptyPassword">Please type your password</p>
      </div>
      <button class="w-full bg-purple-500 hover:bg-purple-700 text-white py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="submit">
        Log In
      </button>
    </form>
    <p class="text-center text-gray-500 text-xs">
      &copy;{{ new Date().getFullYear() }} Garage Manager by Fullsolid. All rights reserved.
    </p>
  </div>
</template>

<script>
import url from 'url'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      email: null,
      password: null,
      url,
    }
  },
  computed: {
    emptyEmail() {
      return this.email === ''
    },
    emptyPassword() {
      return this.password === ''
    },
    ...mapGetters({
      config: 'config/config',
    })
  },
  methods: {
    login: function () {
      let email = this.email
      let password = this.password
      this.$store.dispatch('user/login', { email, password })
        .then(() => this.$router.push('/'))
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Login error',
            text: 'Please check your credentials and try again'
          })
        })
    }
  }
}
</script>
